import { usePrefetchSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/usePrefetchSearchPage";
import { useSearchPageActionName } from "@faire/retailer-visitor-shared/views/search-v2/util/useSearchPageActionName";
import { TelemetryManager } from "@faire/web--source/common/opentelemetry/TelemetryManager";
import { useRef } from "react";
export var useMaybePrefetchSearchPage = function() {
    var name = useSearchPageActionName();
    TelemetryManager.get().startTrace("uplt-".concat(name));
    var prefetchSearchPage = usePrefetchSearchPage();
    var previousPrefetchSearchPageRef = useRef(undefined);
    if (prefetchSearchPage !== previousPrefetchSearchPageRef.current) {
        // Prefetch when the URL changes
        prefetchSearchPage();
        previousPrefetchSearchPageRef.current = prefetchSearchPage;
    }
};
